export const getDashboardJobs = `query GetDashboardJobs($companyId: ID!) {
  getDashboardJobs(companyId: $companyId) {
    openPositions
    inNetworkMatches
    jobShares
    totalJobViews
  }
}
`;
